import { find } from 'lodash';
import { TOKEN_TYPE_FIELD_R } from '../../constants/index';
import Token from './Token.js';
import Expression from './Expression.js';
import { getStrRemoveRFieldByExpressionTree } from '../utils/smartSearchUtils';

export default class ExpressionTree {
    constructor(isRDVersion = false) {
        this.Token = new Token(isRDVersion);
        this.Expression = new Expression(isRDVersion);
    }

    getExpressionTree(text, config) {
        // 切词逻辑，把query分割成list
        const tokenList = this.Token.getTokenList(text, config);
        const expression = this.Expression.getExpression(tokenList);
        return expression;
    }

    getStrRemoveRField(text) {
        const tokenList = this.Token.getTokenList(text);
        const hasR = find(tokenList, {
            type: TOKEN_TYPE_FIELD_R,
        });
        if (!hasR) return text;
        const expression = this.Expression.getExpression(tokenList);
        const str = getStrRemoveRFieldByExpressionTree(expression);
        return str;
    }
}
